import React, { useEffect } from "react";
import { getAppUrl } from "@/utils/domainDetection";

const Index = () => {
  useEffect(() => {
    // Redireciona automaticamente para app.imobpanda.com
    window.location.href = getAppUrl();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-muted-foreground">Redirecionando para o app...</p>
      </div>
    </div>
  );
};

export default Index;
